// User Action Types
export const FETCH_USER_REQUEST = 'users/FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'users/FETCH_USER_SUCCESS';
export const FETCH_USER_FAILURE = 'users/FETCH_USER_FAILURE';

export const FETCH_AWARD_USER_REQUEST = 'users/FETCH_AWARD_USER_REQUEST';
export const FETCH_AWARD_USER_SUCCESS = 'users/FETCH_AWARD_USER_SUCCESS';
export const FETCH_AWARD_USER_FAILURE = 'users/FETCH_AWARD_USER_FAILURE';

export const FETCH_LUCKY_DRAW_USER_REQUEST = 'users/FETCH_LUCKY_DRAW_USER_REQUEST';
export const FETCH_LUCKY_DRAW_USER_SUCCESS = 'users/FETCH_LUCKY_DRAW_USER_SUCCESS';
export const FETCH_LUCKY_DRAW_USER_FAILURE = 'users/FETCH_LUCKY_DRAW_USER_FAILURE';

export const CREATE_USER_REQUEST = 'users/CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'users/CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'users/CREATE_USER_FAILURE';

export const UPDATE_USER_REQUEST = 'users/UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'users/UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'users/UPDATE_USER_FAILURE';
export const UPDATE_USER_RESET = 'users/UPDATE_USER_RESET';

export const DELETE_USER_REQUEST = 'users/DELETE_USER_REQUEST';
export const DELETE_USER_SUCCESS = 'users/DELETE_USER_SUCCESS';
export const DELETE_USER_FAILURE = 'users/DELETE_USER_FAILURE';

export const FETCH_USER_DETAILS_REQUEST = 'users/FETCH_USER_DETAILS_REQUEST';
export const FETCH_USER_DETAILS_SUCCESS = 'users/FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'users/FETCH_USER_DETAILS_FAILURE';

export const GET_PRODUCT_LIST_REQUEST = 'users/GET_PRODUCT_LIST_REQUEST';
export const GET_PRODUCT_LIST_SUCCESS = 'users/GET_PRODUCT_LIST_SUCCESS';
export const GET_PRODUCT_LIST_FAILURE = 'users/GET_PRODUCT_LIST_FAILURE';

export const PAYMENT_SUCCESS = 'users/PAYMENT_SUCCESS';

export const UPDATE_PVS_DATA_REQUEST = 'pvs/UPDATE_PVS_DATA_REQUEST';
export const UPDATE_PVS_DATA_SUCCESS = 'pvs/UPDATE_PVS_DATA_SUCCESS';
export const UPDATE_PVS_DATA_FAILURE = 'pvs/UPDATE_PVS_DATA_FAILURE';
export const UPDATE_PVS_DATA_RESET = 'pvs/UPDATE_PVS_DATA_RESET';

export const RESET_USER_STATE = 'users/RESET_USER_STATE';

export const GET_SYSTEM_USER_LIST_REQUEST = 'users/GET_SYSTEM_USER_LIST_REQUEST';
export const GET_SYSTEM_USER_LIST_SUCCESS = 'users/GET_SYSTEM_USER_LIST_SUCCESS';
export const GET_SYSTEM_USER_LIST_FAILURE = 'users/GET_SYSTEM_USER_LIST_FAILURE';

export const ADD_SYSTEM_USER_REQUEST = 'users/ADD_SYSTEM_USER_REQUEST';
export const ADD_SYSTEM_USER_SUCCESS = 'users/ADD_SYSTEM_USER_SUCCESS';
export const ADD_SYSTEM_USER_FAILURE = 'users/ADD_SYSTEM_USER_FAILURE';
export const ADD_SYSTEM_USER_RESET = 'users/ADD_SYSTEM_USER_RESET';

export const EDIT_SYSTEM_USER_REQUEST = 'users/EDIT_SYSTEM_USER_REQUEST';
export const EDIT_SYSTEM_USER_SUCCESS = 'users/EDIT_SYSTEM_USER_SUCCESS';
export const EDIT_SYSTEM_USER_FAILURE = 'users/EDIT_SYSTEM_USER_FAILURE';
export const EDIT_SYSTEM_USER_RESET = 'users/EDIT_SYSTEM_USER_RESET';

export const REMOVE_SYSTEM_USER_REQUEST = 'users/REMOVE_SYSTEM_USER_REQUEST';
export const REMOVE_SYSTEM_USER_SUCCESS = 'users/REMOVE_SYSTEM_USER_SUCCESS';
export const REMOVE_SYSTEM_USER_FAILURE = 'users/REMOVE_SYSTEM_USER_FAILURE';
export const REMOVE_SYSTEM_USER_RESET = 'users/REMOVE_SYSTEM_USER_RESET';
